import {defaultSchoolIds, filterParams, filterParamsList} from "components/user/unicorn/filter-changed"
import React, {useMemo} from "react"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import CountChart from "components/user/unicorn/count-chart"
import Filter from "components/user/unicorn/filter"
import FrequencyFactors from "components/user/unicorn/frequency-factors"
import isUserA from "components/users/is-a"
import memo from "set-state-compare/build/memo"
import MoodDevelopmentLineChart from "components/score-factors/mood-development-line-chart"
import ProfileBox from "components/user/unicorn/profile-box"
import ProUpgradeOverlay from "components/pro/upgrade-overlay"
import setLayout from "shared/set-layout"
import {Text} from "shared/base"
import UnicornEffects from "components/user/unicorn/unicorn-effects"
import useAnythingPro from "components/subscriptions/use-anything-pro"
import useBreakpoint from "@kaspernj/api-maker/build/use-breakpoint"
import useCurrentUser from "@kaspernj/api-maker/build/use-current-user"
import {useFrontLayout} from "components/front-layout"
import useI18n from "i18n-on-steroids/src/use-i18n.mjs"
import useQueryParams from "on-location-changed/build/use-query-params"
import {View} from "react-native"

export default memo(shapeComponent(class RoutesUserUnicorn extends ShapeComponent {
  firstLoad = true

  setup() {
    setLayout("user")

    const {anythingPro} = useAnythingPro()
    const currentUser = useCurrentUser()
    const {t} = useI18n({namespace: "js.routes.user.unicorn"})

    this.setInstance({
      anythingPro,
      breakpoint: useBreakpoint(),
      currentUser,
      queryParams: useQueryParams(),
      t
    })
    this.useStates({
      classStepIds: null,
      dateFrom: null,
      dateTo: null,
      loaded: false,
      schoolClassIds: null,
      schoolClassGroupIds: null,
      schoolIds: null
    })

    const filterQueryParams = []

    for (const filterParamName of filterParamsList) {
      filterQueryParams.push(this.queryParams[filterParamName])
    }

    useMemo(() => {
      if (this.tt.firstLoad) {
        this.firstLoad = false
        this.setDataFromDefaults()
      } else {
        this.setDataFromQueryParams()
      }
    }, filterQueryParams)

    useFrontLayout()?.setState({active: "user-unicorn", centered: false, headTitle: t(".analysis")})
  }

  setDataFromDefaults = async () => {
    const {dateFrom, dateTo, classStepIds, schoolClassIds, schoolClassGroupIds, schoolIds} = await defaultSchoolIds(this.tt.queryParams)

    this.setState({
      classStepIds,
      dateFrom,
      dateTo,
      loaded: true,
      schoolClassIds,
      schoolClassGroupIds,
      schoolIds
    })
  }

  setDataFromQueryParams = () => {
    const {classStepIds, dateFrom, dateTo, schoolClassIds, schoolClassGroupIds, schoolIds} = filterParams(this.tt.queryParams)

    this.setState({
      classStepIds,
      dateFrom,
      dateTo,
      loaded: true,
      schoolClassIds,
      schoolClassGroupIds,
      schoolIds
    })
  }

  render() { // eslint-disable-line complexity
    const {anythingPro, breakpoint, currentUser, t} = this.tt
    const {classStepIds, dateFrom, dateTo, loaded, schoolClassIds, schoolClassGroupIds, schoolIds} = this.s
    const filterProps = {
      classStepIds,
      dateFrom,
      dateTo,
      schoolClassIds,
      schoolClassGroupIds,
      schoolIds
    }
    const hasAnyModelsSelected = this.hasAnyModelsSelected()

    return (
      <View dataSet={this.rootViewStyle ||= {route: "user--unicorn"}}>
        {anythingPro === false &&
          <ProUpgradeOverlay />
        }
        {anythingPro === true && loaded &&
          <>
            <View
              dataSet={this.unicornHeaderDataSet ||= {class: "unicorn-header"}}
              style={this.unicornHeaderStyle ||= {
                flexDirection: "row",
                flexWrap: "wrap",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: 30
              }}
            >
              <View
                dataSet={this.filterContainerDataSet ||= {class: "filter-container"}}
                style={this.cache("filterContainerStyle", {
                  marginTop: breakpoint.xlUp ? 0 : 30,
                  marginLeft: "auto",

                  flexShrink: breakpoint.xlUp ? 1 : undefined,
                  flexWrap: breakpoint.xlUp ? "wrap" : undefined,
                  justifyContent: breakpoint.xlUp ? "center" : undefined
                }, [breakpoint.xlUp])}
              >
                <Filter {...filterProps} />
              </View>
            </View>
            {!hasAnyModelsSelected &&
              <Text>
                {t(".please_select_a_school_or_a_class")}
              </Text>
            }
            {hasAnyModelsSelected &&
              <>
                <View
                  dataSet={this.unicornEffectsAndCountChartDataSet ||= {class: "unicorn-effects-and-count-chart"}}
                  style={this.unicornEffectsAndCountStyle ||= {flexDirection: "row", marginBottom: 50}}
                >
                  <UnicornEffects {...filterProps} />
                  <View style={this.countChartViewStyle ||= {flexGrow: 1}}>
                    <CountChart {...filterProps} />
                  </View>
                </View>
                <View style={this.moodFreqAndProfileViewStyle ||= {flexDirection: "row"}}>
                  <View style={this.moodDevelopmentLineChartViewStyle ||= {width: 700}}>
                    <MoodDevelopmentLineChart {...filterProps} />
                  </View>
                  <View style={this.frequencyFactorsViewStyle ||= {width: 350, marginLeft: 30}}>
                    <FrequencyFactors {...filterProps} />
                  </View>
                  {isUserA(currentUser, "tester") &&
                    <View style={this.profileBoxViewStyle ||= {width: 350, marginLeft: 30}}>
                      <ProfileBox />
                    </View>
                  }
                </View>
              </>
            }
          </>
        }
      </View>
    )
  }

  hasAnyModelsSelected() {
    if (this.s.classStepIds?.length > 0 || this.s.schoolClassIds?.length > 0 || this.s.schoolClassGroupIds?.length > 0 || this.s.schoolIds?.length > 0) {
      return true
    }

    return false
  }
}))
